<template>
  <div>
    <div class="card" v-if="indexationProduitTab && indexationProduitTab.length === 0">
      <div class="has-text-centered pdt-20px pdb-20px">
        <h1 class="title is-size-4">
          {{ $t('indexation.noAnneeSelect')}}
        </h1>
        <p> {{ $t('indexation.selectAnnee')}} </p>
      </div>
    </div>
    <div class="columns is-multiline" v-else>
      <div class="column is-4 is-offset-8 has-text-right">
        <div class="columns">
          <div class="column is-10 has-text-weight-bold
        has-text-default mgt-7px">
            {{ $t('indexation.tauxGeneral') }}
          </div>
          <b-input v-model="tauxGeneral"
                   @input="$emit('updateIndexation', 'pourcentageIndexationParDefaut', $event)"
                   class="column is-2 pdl-0"
                   type="number">
          </b-input>
        </div>
      </div>
      <div class="column is-12" v-if="indexationProduitTab">
        <v-client-table :data="indexationProduitTab"
                        :columns="columns"
                        :options="options"
                        ref="tabProduit">
          <div slot="produit" slot-scope="props">
            {{ $t(props.row.libelle) }}
          </div>
          <div slot="beforeYearSelect" slot-scope="props">
            {{ $t(props.row.valueYearBeforeSelect ? 'general.oui' : 'general.non') }}
          </div>
          <div slot="yearSelect" slot-scope="props">
            <qd-switch :value="props.row.valueYearSelect"
                      @input="$emit('updateIndexation', props.row.propriete, $event)">
            </qd-switch>
          </div>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import genererTabProduitIndexation from '@/services/parametrage/indexation/genererTabProduit';
import {
  RESULTS_PER_PAGE,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';

export default {
  name: 'IndexationProduit',
  props: {
    indexationYearSelect: {
      type: Object,
      required: false,
    },
    indexationPreviousYearSelect: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      indexationProduitTab: null,
      tauxGeneral: null,
    };
  },
  computed: {
    columns() {
      if (!this.indexationPreviousYearSelect) return ['produit', 'yearSelect'];
      return ['produit', 'beforeYearSelect', 'yearSelect'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          produit: this.$i18n.t('indexation.produit.tab.select'),
          beforeYearSelect: this.indexationPreviousYearSelect
            ? this.indexationPreviousYearSelect.annee : null,
          yearSelect: this.indexationYearSelect ? this.indexationYearSelect.annee : null,
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          beforeYearSelect: 'colonneAction',
          yearSelect: 'colonneAction',
        },
      };
    },
  },
  methods: {
    async updateValueBase() {
      this.indexationProduitTab = null;
      this.indexationProduitTab = await genererTabProduitIndexation(
        cloneDeep(this.indexationYearSelect), cloneDeep(this.indexationPreviousYearSelect),
      );
      this.tauxGeneral = this.indexationYearSelect
        ? this.indexationYearSelect.pourcentageIndexationParDefaut : null;
    },
  },
  mounted() {
    this.updateValueBase();
  },
};

</script>
